import React from "react";
import Resume from "../resource/resume2.png";
import "./ResumePage.css";
import Name from "../components/Name";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import resumePic from "../resource/resumePic1.png";

function ResumePage(props) {
  return (
    <div className="resumePage">
      <img src={Resume} alt="" style={{ height: "720px" }} />
      <div
        className="resumeContainer"
        style={{
          backgroundImage: `url(${resumePic})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Name
          text={"link to my resume"}
          styles={{
            color: "black",
            marginTop: "215px",
            fontWeight: 700,
            fontSize: "60px",
            fontFamily: "Futura PT, sans-serif",
          }}
        />
        <div
          style={{
            width: "210px",
            height: "50px",
            // position: "absolute",
            backgroundColor: "#FFEB00",
            // right: "231px",
            // top: "298px",
            borderRadius: "40px",
            boxShadow: "0 0 10px #5D6D7E",
            opacity: 1,
            marginTop: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <FontAwesomeIcon
              icon={faArrowRight}
              style={{ color: "red" }}
              size="2x"
            />
            <a
              href="https://drive.google.com/file/d/16jxd-iFt3a954PbzMMTWbiXKuBucqwch/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                fontSize: "30px",
                color: "red",
                marginLeft: "20px",
              }}
            >
              Click here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ResumePage;
